module.exports = dependencies['react']['16.13.1']['module'];